var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 63,
    viewBox: "0 0 84 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34.7866C0 42.0416 2.61544 48.6527 6.91933 53.6491C11.8569 59.3829 19.0168 62.9879 26.9977 63C30.4857 63.0052 33.8209 62.3198 36.8843 61.0686C38.4683 60.4214 40.2412 60.4957 41.7753 61.2625C43.5749 62.1607 45.59 62.6643 47.7178 62.6643C48.5968 62.6643 49.4576 62.5777 50.2902 62.4134C52.6669 61.9461 54.8297 60.8402 56.6059 59.2739C57.7222 58.2891 59.1518 57.7942 60.613 57.7959H60.6378C65.4659 57.7959 69.9506 56.2678 73.674 53.6491C77.0027 51.3111 79.7209 48.1023 81.5321 44.3348C83.1111 41.0517 84 37.3429 84 33.4176C84 19.9548 73.5395 9.03934 60.6378 9.03934C59.3225 9.03934 58.0339 9.15526 56.7768 9.37157C53.4481 3.74851 47.4872 0 40.6872 0C37.8163 0 35.0946 0.668095 32.6583 1.86571C30.3413 3.00096 28.2813 4.6141 26.5962 6.58C20.8742 6.67519 15.5834 8.62574 11.253 11.881C4.4365 17.0022 0 25.3544 0 34.7866Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.3ceb9233b0030fefe1dbfabfb7fc02a5.svg";
export { ForwardRef as ReactComponent };